'use strict';

var cubicBezier = require('./cubic-bezier.cjs');

const supportedWaapiEasing = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ cubicBezier.cubicBezierAsString([0, 0.65, 0.55, 1]),
    circOut: /*@__PURE__*/ cubicBezier.cubicBezierAsString([0.55, 0, 1, 0.45]),
    backIn: /*@__PURE__*/ cubicBezier.cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
    backOut: /*@__PURE__*/ cubicBezier.cubicBezierAsString([0.33, 1.53, 0.69, 0.99]),
};

exports.supportedWaapiEasing = supportedWaapiEasing;
//# sourceMappingURL=supported.cjs.map
